import { FC, useState } from 'react';

import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { message, Typography, Upload } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import { UploadFile } from 'antd/lib';

import { ActionButton } from '@hdi-seguros/web-components.action-button';
import {
  ColSize,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { Modal } from '@hdi-seguros/web-components.modal';
import { SectionQuotation } from '../../../../../../../shared';
import { UploadFileModal } from '../';

import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface ComplementaryDocumentsProps {
  fileSelect: UploadFile[];
  setFileSelect: React.Dispatch<React.SetStateAction<UploadFile<any>[]>>;
}

export const ComplementaryDocuments = ({ fileSelect, setFileSelect }: ComplementaryDocumentsProps) => {
  const [canShowConfirmDeleteAllModal, setCanShowConfirmDeleteAllModal] =
    useState<boolean>(false);
  const [canShowConfirmDeleteModal, setCanShowConfirmDeleteModal] =
    useState<boolean>(false);
  const [
    canShowUploadModalTypesDocuments,
    setCanShowUploadModalTypesDocuments,
  ] = useState<boolean>(false);
  const [canShowUploadModalUploadFile, setCanShowUploadModalUploadFile] =
    useState<boolean>(false);
  const [fileSelectDelete, setFileSelectDelete] = useState<UploadChangeParam>();

  

  const openFile = (file: any) => {
    let messageError: string =
      'No hay archivo seleccionado o el archivo está vacío.';

    if (file.base) {
      const newWindow = window.open();

      if (newWindow) {
        const document: string = `<iframe src="${file.base}" style="width:100%; height:100%;"></iframe>`;
        newWindow.document.write(document);
        return;
      }

      messageError =
        'La ventana emergente no se pudo abrir. Asegúrate de que las ventanas emergentes no estén bloqueadas en tu navegador.';
    }

    message.error(messageError);
  };

  const handleFileSelection = async (
    info: UploadChangeParam<UploadFile<any>>
  ) => {
    if (info.file.status === 'removed') {
      setFileSelectDelete(info);
      setCanShowConfirmDeleteModal(true);
    }
  };

  const handleConfirmDelete = () => {
    setCanShowConfirmDeleteModal(true);

    const updatedFiles = fileSelect.filter(
      (file: { uid: string }) => file.uid !== fileSelectDelete?.file.uid
    );

    setFileSelect(updatedFiles);
    setFileSelectDelete(undefined);

    setCanShowConfirmDeleteModal(false);
  };

  const handleConfirmDeleteAll = () => {
    setFileSelect([]);
    setCanShowConfirmDeleteAllModal(false);
  };

  const handleCancelDelete = () => {
    setFileSelectDelete(undefined);
    setCanShowConfirmDeleteModal(false);
  };

  return (
    <>
      <SectionQuotation
        level='h3'
        title='Documentos Complementarios'
        hasCard={false}
      >
        <RowSize>
          <ColSize size={100}>
            <Typography.Text>
              Estimado, el envío de archivos por este medio no implica la
              aceptación automática de los mismos por parte de la compañía.
              <br />
              Valide{' '}
              <Typography.Link
                strong
                style={{ color: COLORS.secondary[100] }}
                onClick={() => setCanShowUploadModalTypesDocuments(true)}
              >
                aquí
              </Typography.Link>{' '}
              los documentos que puede adjuntar.
            </Typography.Text>
          </ColSize>
        </RowSize>
        <RowSize className='mt-1' rowProps={{ gutter: [0, 0] }}>
          <RowSize>
            <ColSize size={100}>
              <Typography.Text type='secondary'>
                Archivo factura
              </Typography.Text>
            </ColSize>
          </RowSize>
          <RowSize>
            <ColSize size={100}>
              <ActionButton
                className='btn-accent-outline-barbuss mr-1'
                icon={<UploadOutlined />}
                label='Subir'
                onClick={() => setCanShowUploadModalUploadFile(true)}
                type='secondary'
              />
              <ActionButton
                className={fileSelect.length > 0 ? '' : 'opacity-low'}
                color='danger'
                disabled={fileSelect.length === 0}
                icon={<DeleteOutlined />}
                label='Limpiar'
                onClick={() => setCanShowConfirmDeleteAllModal(true)}
                type='secondary'
              />
            </ColSize>
          </RowSize>
          <ColSize className='mt-1' size={50}>
            <Upload
              fileList={fileSelect}
              onPreview={(file) => openFile(file)}
              onChange={(info: UploadChangeParam) => handleFileSelection(info)}
            />
          </ColSize>
        </RowSize>
      </SectionQuotation>

      <UploadFileModal
        canShowUploadModalUploadFile={canShowUploadModalUploadFile}
        setCanShowUploadModalUploadFile={setCanShowUploadModalUploadFile}
        setFileSelect={setFileSelect}
      
      />

      <Modal
        centered
        className='mt-1'
        footer={
          <ActionButton
            label='Cerrar'
            type='secondary'
            onClick={() => setCanShowUploadModalTypesDocuments(false)}
            width={115}
          />
        }
        onCancel={() => setCanShowUploadModalTypesDocuments(false)}
        open={canShowUploadModalTypesDocuments}
        title='Tipos de Documentos'
        width={650}
      >
        <RowSize>
          <ColSize size={100}>
            <Typography.Text>
              Podrá adjuntar los siguientes archivos complementarios:
            </Typography.Text>
          </ColSize>

          <ColSize size={100}>
            <ul>
              <li>Copia de la Factura de compra del vehículo.</li>
              <li>Certificado de no rodamiento.</li>
              <li>Cédula amarilla de GNC.</li>
              <li>Factura de compra de accesorios.</li>
              <li>Copia del Título de propiedad.</li>
              <li>Cédula verde.</li>
              <li>Certificado de blindaje emitido por RENAR.</li>
              <li>Inspección de la última VTV.</li>
            </ul>
          </ColSize>
        </RowSize>
      </Modal>

      <Modal
        centered
        className='mt-1'
        footer
        onCancel={handleCancelDelete}
        onOk={handleConfirmDelete}
        open={canShowConfirmDeleteModal}
        title='Eliminar archivo'
        width={650}
      >
        <RowSize className='mb-1'>
          <ColSize size={100}>
            <Typography.Text>
              ¿Está seguro de que desea eliminar el archivo:{' '}
              {fileSelectDelete?.file?.name}?
            </Typography.Text>
          </ColSize>
        </RowSize>
      </Modal>

      <Modal
        centered
        className='mt-1'
        footer
        onCancel={() => setCanShowConfirmDeleteAllModal(false)}
        onOk={handleConfirmDeleteAll}
        open={canShowConfirmDeleteAllModal}
        title='Eliminar archivo'
        width={650}
      >
        <RowSize className='mb-1'>
          <ColSize size={100}>
            <Typography.Text>
              ¿Está seguro de que desea eliminar todos los archivos cargados?
            </Typography.Text>
          </ColSize>
        </RowSize>
      </Modal>
    </>
  );
};
